import React from "react";
import { FaTwitter } from "react-icons/fa";

function Footer() {
  return (
    <div>
      <footer className="footer-style-one box-layout bg-dark text-light">
        <div className="footer-shape">
          <img
            src="https://validthemes.net/site-template/robok/assets/img/shape/globe.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="f-items default-padding">
            <div className="row">
              <div className="col-xl-3 col-lg-5">
                <div className="f-item contact">
                  <h4 className="widget-title"> Contact</h4>
                  <ul className="contact">
                    <li>
                      <p>Phone Number</p>
                      <h4>
                        <a href="https://wa.me/+917383847632" target="_blank">
                          +91 7383847632
                        </a>
                      </h4>
                    </li>
                    <li>
                      <p>Email</p>
                      <h4>
                        <a
                          href="mailto:sales@xeertechnology.com"
                          target="_blank"
                        >
                          sales@xeertechnology.com
                        </a>
                      </h4>
                    </li>
                  </ul>
                  {/*  */}
                  <div className=" pt-5">
                    <div className="">
                      <div className=" align-items-end">
                        <img
                          style={{ width: "27px" }}
                          src="../assets/img/shape/ind.svg"
                          alt="gujarat"
                          className="img-fluid"
                        />

                        <p className="">Gujarat, India</p>
                      </div>
                    </div>
                    <div className=" ">
                      <div className=" align-items-end">
                        <img
                          style={{ width: "35px" }}
                          src="../assets/img/shape/uae.svg"
                          alt="dubai"
                          className="img-fluid"
                        />
                        <p className="">Dubai, UAE</p>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                </div>
              </div>
              <div className="col-xl-8 offset-xl-1 col-lg-7">
                <div className="footer-style-one-items">
                  <div className="f-item link">
                    <h4 className="widget-title">Solutions</h4>
                    <ul>
                      {/* <li>
                        <a href="/decentralized-exchange">
                          Decentralized Exchange
                        </a>
                      </li> */}
                      <li>
                        <a href="/dex-aggregator">Dex Aggregator</a>
                      </li>
                      <li>
                        <a href="/amm-dex">AMM Dex</a>
                      </li>
                      <li>
                        <a href="/order-book-dexs">Order Book Dexs</a>
                      </li>
                      <li>
                        <a href="/token-development">Coin/Token Development</a>
                      </li>
                      <li>
                        <a href="/ido-development">IDO Development</a>
                      </li>
                      <li>
                        <a href="/crypto-launchpad">Crypto Launchpad</a>
                      </li>
                      <li>
                        <a href="/ico-development">ICO Development</a>
                      </li>
                    </ul>
                  </div>

                  <div className="f-item link">
                    <h4 className="widget-title">Services</h4>
                    <ul>
                      {/* <li>
                          <a href="/cryptocurrency-exchange">
                            Exchange Development
                          </a>
                        </li> */}
                      <li>
                        <a href="/nft-development">NFT Development</a>
                      </li>
                      <li>
                        <a href="/crypto-banking">Crypto Banking</a>
                      </li>
                      <li>
                        <a href="/cryptocurrency-payment-gateway">
                          Cryptocurrency Payment Gateway
                        </a>
                      </li>
                      <li>
                        <a href="/crypto-gaming">Crypto Gaming</a>
                      </li>
                      <li>
                        <a href="/web-30-devlopment">Web3 Development</a>
                      </li>
                      <li>
                        <a href="/web3-game-devlopment">
                          Web3 Game Development
                        </a>
                      </li>
                      <li>
                        <a href="/trading-bot">Trading Bots</a>
                      </li>
                    </ul>
                  </div>

                  <div className="f-item link">
                    <h4 className="widget-title">Company</h4>
                    <ul>
                      <li>
                        <a href="/about-us">About Us</a>
                      </li>
                      <li>
                        <a href="/contact-us">Contact Us</a>
                      </li>
                      <li>
                        <a href="/career">Career</a>
                      </li>
                      {/* <li>
                        <a
                          href="https://drive.google.com/file/d/1iqlu5hDjaOX_wm0p_L06lxSSbUfeUSsC/view?usp=sharing"
                          target="_blank"
                        >
                          Media Files
                        </a>
                      </li> */}
                    </ul>
                  </div>
                  <div className="f-item link">
                    <h4 className="widget-title">Smart Contract</h4>
                    <ul>
                      <li>
                        <a href="/mlm"> MLM Smart Contract</a>
                      </li>
                      <li>
                        <a href="/ethereum">Ethereum</a>
                      </li>
                      <li>
                        <a href="/polygon-edge">Polygon</a>
                      </li>
                      <li>
                        <a href="/solana">Solana Smart Contract</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-one">
          <div className="container">
            <div className="row align-center">
              <div className="col-lg-6 col-md-6">
                <div className="logo">
                  <a href="/">
                    <img
                      src="../assets/img/new_final_logo_xeer_horizontal_white.svg"
                      alt="Logo"
                    />
                  </a>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <ul className="footer-item-social text-end">
                  <li>
                    <a
                      href="https://www.facebook.com/people/Xeer-Technology/61555342661387/"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/technology_xeer" target="_blank">
                      <FaTwitter size={20} />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/xeer.technology/"
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/xeer-technology/"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <p>
                  <a href="#">XEER Technology</a> © 2026 All Rights Reserved.
                </p>
              </div>
              <div className="col-lg-6 text-end">
                <ul>
                  <li>
                    <a href="/terms-and-conditions">Terms & Conditions</a>
                  </li>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
